import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
import { SectionWrapper } from '../ui/SectionWrapper';
export function SocialProof() {
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  const staggerContainer = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const testimonials = [{
    quote: "Aplicar el concepto de 'Lenguaje Presuposicional' cambió por completo mis reuniones de directorio. Ya no discuto ideas, simplemente guío a los socios hacia la conclusión que necesito.",
    name: 'Martín V.',
    role: 'Consultor Estratégico',
    initials: 'MV'
  }, {
    quote: 'Siempre sentí que en las negociaciones terminaba cediendo para mantener la relación. Este manual me dio la estructura técnica para mantener mi marco sin parecer agresivo.',
    name: 'Laura S.',
    role: 'CEO & Fundadora',
    initials: 'LS'
  }, {
    quote: 'Es como tener el código fuente de las interacciones humanas. Lo apliqué en una venta B2B compleja que llevaba meses estancada y cerramos en dos semanas.',
    name: 'Diego R.',
    role: 'Director Comercial',
    initials: 'DR'
  }];
  const forWho = ['Personas que necesitan que sus ideas y visiones se ejecuten.', 'Profesionales que operan en entornos competitivos o de alta jerarquía.', 'Emprendedores que negocian con socios, proveedores o clientes difíciles.', 'Cualquiera que quiera dejar de ser un espectador y empezar a ser el arquitecto de su realidad social.'];
  const notForWho = ["Quienes buscan 'limpiar mentes' o trucos mágicos. Esto es psicología técnica aplicada."];
  return <SectionWrapper className="bg-bg" data-id="element-147">
      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={staggerContainer} data-id="element-148">
        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-24" data-id="element-149">
          {testimonials.map((test, idx) => <motion.div key={idx} variants={fadeUp} className="bg-surface border border-border p-8 rounded-xl flex flex-col justify-between" data-id="element-150">
              <p className="font-body text-text-secondary italic leading-relaxed mb-8" data-id="element-151">
                "{test.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-152">
                <div className="w-10 h-10 rounded-full bg-bg border border-border flex items-center justify-center font-heading font-bold text-text-primary text-sm" data-id="element-153">
                  {test.initials}
                </div>
                <div data-id="element-154">
                  <h4 className="font-heading font-bold text-text-primary text-sm" data-id="element-155">
                    {test.name}
                  </h4>
                  <p className="font-body text-xs text-text-secondary" data-id="element-156">
                    {test.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Who is it for / not for */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-157">
          <motion.div variants={fadeUp} className="bg-surface border border-border rounded-xl p-8" data-id="element-158">
            <h3 className="font-heading font-bold text-xl text-text-primary mb-6 uppercase tracking-wide" data-id="element-159">
              ¿Para quién es esto?
            </h3>
            <ul className="space-y-4" data-id="element-160">
              {forWho.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-161">
                  <Check className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-162" />
                  <span className="font-body text-sm text-text-secondary leading-relaxed" data-id="element-163">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div variants={fadeUp} className="bg-surface/50 border border-border/50 rounded-xl p-8" data-id="element-164">
            <h3 className="font-heading font-bold text-xl text-text-primary mb-6 uppercase tracking-wide opacity-80" data-id="element-165">
              ¿Para quién NO es?
            </h3>
            <ul className="space-y-4" data-id="element-166">
              {notForWho.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-167">
                  <X className="w-5 h-5 text-red-500/70 shrink-0 mt-0.5" data-id="element-168" />
                  <span className="font-body text-sm text-text-secondary leading-relaxed opacity-80" data-id="element-169">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </motion.div>
    </SectionWrapper>;
}